import { render, staticRenderFns } from "./kehuyixiang.vue?vue&type=template&id=35f20c42&scoped=true"
import script from "./kehuyixiang.vue?vue&type=script&lang=js"
export * from "./kehuyixiang.vue?vue&type=script&lang=js"
import style0 from "./kehuyixiang.vue?vue&type=style&index=0&id=35f20c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f20c42",
  null
  
)

export default component.exports